import script from "./dynamicSkeleText.vue?vue&type=script&lang=js"
export * from "./dynamicSkeleText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/dynamicSkeleText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d94a224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d94a224', __exports__)) {
    api.reload('6d94a224', __exports__)
  }
  
}


export default __exports__